<template>
	<div style="display: grid; gap: 30px; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); align-items: start">
		<DashboardItem title="Top">
			<template v-slot:main>
				<Table
					:head="tableHeader"
					:stickyHead="true"
					:size="tableSizes">
					<TransitionGroup name="list">
						<TableRow
							:size="tableSizes"
							:key="`${item.dispatcher}:${item['truck#']}`"
							v-for="item of listOfDispatchers.best">
							<div class="dispatcher-name">
								<a
									href=""
									@click.prevent=""
									><span style="text-transform: capitalize">{{ item.dispatcher_full_name }}</span></a
								>
							</div>
							<div class="truck-number">{{ item.truckNumber }}</div>
							<div>
								<strong>{{ CURRENCY.format(item.total_load_pay) }}</strong>
							</div>
						</TableRow>
					</TransitionGroup>
				</Table>
			</template>
		</DashboardItem>

		<DashboardItem title="Underdogs">
			<template v-slot:main>
				<Table
					:head="tableHeader"
					:stickyHead="true"
					:size="tableSizes">
					<TransitionGroup name="list">
						<TableRow
							:size="tableSizes"
							:key="`${item.dispatcher}:${item['truck#']}`"
							v-for="item of listOfDispatchers.worst">
							<div class="dispatcher-name">
								<a
									href=""
									@click.prevent=""
									><span style="text-transform: capitalize">{{ item.dispatcher_full_name }}</span></a
								>
							</div>
							<div class="truck-number">{{ item.truckNumber }}</div>
							<div>
								<strong>{{ CURRENCY.format(item.total_load_pay) }}</strong>
							</div>
						</TableRow>
					</TransitionGroup>
				</Table>
			</template>
		</DashboardItem>
	</div>
</template>

<script>
import DashboardItem from "../DashboardItem.vue";

export default {
	components: {
		DashboardItem,
	},
	props: ["stats"],
	computed: {
		listOfDispatchers() {
			try {
				const arr = JSON.parse(JSON.stringify(this.stats.all)).sort((a, b) => b.total_load_pay - a.total_load_pay);

				const middleIndex = Math.floor(arr.length / 2);
				const firstHalf = arr.slice(0, middleIndex);

				const secondHalf = arr.slice(middleIndex);
				secondHalf.sort((a, b) => a.total_load_pay - b.total_load_pay);

				return { best: firstHalf.slice(0, 10), worst: secondHalf.slice(0, 10) };
			} catch (e) {
				return { best: [], worst: [] };
			}
		},
		tableHeader() {
			return [{ name: "Dispatcher" }, { name: "Truck" }].concat([{ name: "Gross" }]);
		},
		tableSizes() {
			return ["minmax(0, 1fr)", "minmax(100px, 150px)"].concat(["minmax(100px, 150px)"]);
		},
	},
};
</script>

<style lang="scss" scoped></style>
